import { getCustomReferenceTypeForProperty } from './getCustomReferenceTypeForProperty';
export function isCustomExternalOptionsProperty(property, objectTypeId) {
  return !!getCustomReferenceTypeForProperty(property, objectTypeId);
}